// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Daq3of4EeUhk1wEQZqGI{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);cursor:default;border-radius:6px;align-items:center;height:24px;margin-bottom:6px;margin-right:6px;padding:0 0 0 8px;display:flex}.gvysojBIrgPJyuEznmro{margin-right:8px}.OXMiVj8idzQuAngJGOnQ{color:var(--content-primary-primary);white-space:nowrap;text-overflow:ellipsis;max-width:65px;margin-right:8px;font-size:13px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Daq3of4EeUhk1wEQZqGI`,
	"item__avatar": `gvysojBIrgPJyuEznmro`,
	"itemAvatar": `gvysojBIrgPJyuEznmro`,
	"item__name": `OXMiVj8idzQuAngJGOnQ`,
	"itemName": `OXMiVj8idzQuAngJGOnQ`
};
export default ___CSS_LOADER_EXPORT___;
